import { FC } from 'react'
import { FirmDetailsPolicyData } from 'src/dtos/portal'
import {
  FirmViewSectionContainer,
  FlexDiv,
  OrangeButton,
} from '../index'
import { HiOutlineCalendar } from 'react-icons/hi'
import { numberToSimple } from 'src/utils/numberFormat'
import { format } from 'date-fns'
import { useAuth } from 'src/context/auth'
interface FirmViewPolicyProps {
  policyData?: FirmDetailsPolicyData;
  firmId?: number;
}

const FirmViewPolicy: FC<FirmViewPolicyProps> = ({ policyData, firmId }) => {
  const { user } = useAuth()

  const handleDownloadPolicy = async () => {
    const url = `/api/Firm/policydocument/${firmId}`;
    return window.open(url);
  }

  return (
    <FirmViewSectionContainer>
      <FlexDiv align='center' justify='space-between'>
        <FlexDiv dir='column' gap="12px">
          {policyData?.policyType ? (
            <h5>
              {policyData.policyType.toUpperCase() === 'BASIC'
                ? 'ESSENTIAL'
                : policyData.policyType.toUpperCase() === 'REGULAR'
                  ? 'PREMIERE'
                  : policyData.policyType.toUpperCase()} POLICY
            </h5>
          ) : null}
          <h1 style={{ color: user.role === 'Client' ? '#937251' : '#3D6666' }} >Policy Number {policyData?.policyKey ?? ''}</h1>
        </FlexDiv>
        <OrangeButton onClick={handleDownloadPolicy}>
          View Policy (PDF)
        </OrangeButton>
      </FlexDiv>
      <FlexDiv dir='column' margin='32px 0 0'>
        <h5>POLICY DETAILS</h5>
        <hr style={{ marginTop: '8px' }} />
        {policyData ? (
          <FlexDiv margin="24px 0 0 0">
            <FlexDiv dir='column' gap="22px">
              <article>
                <h5>Per Claim Limit</h5>
                <h2>{numberToSimple(policyData.perClaimLimit)}</h2>
              </article>
              <article>
                <h5>Expense Allowance</h5>
                <h2>{numberToSimple(policyData.expenseAllowance)}</h2>
              </article>
            </FlexDiv>
            <FlexDiv dir='column' gap="22px">
              <article>
                <h5>Aggregate Limit</h5>
                <h2>{numberToSimple(policyData.aggregateLimit)}</h2>
              </article>
              <article>
                <h5>Premium</h5>
                <h2>{numberToSimple(Math.round(policyData.premium),5)}</h2>
              </article>
            </FlexDiv>
            <FlexDiv dir='column'>
              <article>
                <h5>Aggregate Deductible</h5>
                <h2>{numberToSimple(policyData.aggregateDeductible)}</h2>
              </article>
            </FlexDiv>
          </FlexDiv>
        ) : (
          <h3 style={{ marginTop: '64px' }}>Loading...</h3>
        )}
      </FlexDiv>
      {policyData ? (
        <FlexDiv dir="column" margin='48px 0 0 0'>
          <h5>DATES OF COVERAGE</h5>
          <hr style={{ marginTop: '8px' }} />
          <FlexDiv margin="24px 0 0 0" maxWidth='fit-content'>
            <table>
              <tbody>
                <tr>
                  <td>
                    <h5>
                      <HiOutlineCalendar />
                      Effective Date
                    </h5>
                  </td>
                  <td style={{ paddingLeft: '20px' }}>
                    <h6>
                      {format(new Date(policyData.policyEffectiveDate), 'MM/dd/yyyy')}
                    </h6>
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingTop: '20px' }}>
                    <h5>
                      <HiOutlineCalendar />
                      Expiration Date
                    </h5>
                  </td>
                  <td style={{ padding: '20px 0 0 20px' }}>
                    <h6>
                      {format(new Date(policyData.policyExpiryDate), 'MM/dd/yyyy')}
                    </h6>
                  </td>
                </tr>
              </tbody>
            </table>
          </FlexDiv>
        </FlexDiv>
      ) : null}
    </FirmViewSectionContainer>
  )
}

export default FirmViewPolicy